import React from 'react'
import fatelError from '../../../icons/fatal-error.svg'
import redCross from '../../../icons/icon-red-cross.svg'
import style from "../css/Sf.module.css";
import { useNavigate } from 'react-router-dom';

function Fail() {
  const navigate = useNavigate();
  const machineId = localStorage.getItem('mId');
  const machineType = localStorage.getItem('machineType');

  
  const onCheckoutClick = () => {
    navigate('/'+machineType +'/'+machineId+'/');
  };
  
  return (
    <div className={`${style.sfWrapper}`}>
        <div className={`${style.fatelError}`}>
          <img src={fatelError} style={{ width: "100%"}} />
        </div>

        <div className={`text-center ${style.errorBtn}`}>
          <img src={redCross}/>
        </div>

        <h3 className={`text-center green`}>Payment Failed</h3>

        <button onClick={() => onCheckoutClick()} className={`${style.checkoutBtn}`}>
            Retry
          </button>
    </div>
  )
}

export default Fail

